<template>
  <div class="index">
    <img src="../../../assets/shared-hotel/loading.gif" />
  </div>
</template>
<script>
export default {
  data() {
    return {
      equipment: 10, //10安卓，11ios
    };
  },
  created() {
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
      sessionStorage.setItem("token", JSON.stringify(this.$route.query.token));
    }
    this.deductionUA();
    this.initData();
  },
  mounted() {},
  methods: {
    initData() {
      if (this.equipment == 10) {
        this.params("", "1", "decorateBackOff");
      }
      // 获取是否是代理人
      this.$api
        .get("decoration/member/city/agent/exists", {
          category: "initialization",
        })
        .then((res) => {
          let path = "";
          // 如果是个人代理人或者是企业代理人进入详情页面否则进入申请页
          if (res.jump_enterprise_agent || res.jump_individual_agent) {
            path = "/decoration/deputy/details";
          } else {
            path = "/decoration/deputy/home";
          }
          this.$router.push({
            path: path,
          });
        });
    },
    // 判断手机机型
    deductionUA() {
      const ua = navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod/.test(ua)) {
        this.equipment = 11;
      } else if (/android/.test(ua)) {
        this.equipment = 10;
      }
    },
  },
};
</script>
<style lang="less">
.index {
  text-align: center;
  width: 100%;
  height: 100%;
  img {
    width: 35%;
    margin-top: 65%;
  }
}
</style>